//create a custom element for the product-cart-item
class ProductCartItem extends HTMLElement {
  constructor() {
    super();
  }
  //on click .btn-atc, add the product to the cart
  connectedCallback() {
    this.querySelector(".btn-atc").addEventListener("click", this.addToCart);
  }
  addToCart() {
    console.log(this);
    const variantId = this.dataset.variantId;

    //clear all products from cart shopify api
    fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then(() => (window.location.href = "/checkout"))
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}
customElements.define("product-cart-item", ProductCartItem);
